import { Box, Typography, Button } from "@mui/material";
import { setRejectModalOpen } from "../../store/job/jobSlice";
import { useDispatch } from "react-redux";

const ProofBody = ({ proof_data, onApprove, onReject, proofLoading }) => {
  const dispatch = useDispatch();
  const allRejected = proof_data.every(item => item.sent_approved_files === 3);
  const allApproved = proof_data.every(item => item.sent_approved_files === 2);

  return (
    <>
      {/* Proofs */}
      <Box sx={{ my: 2, minHeight: 200 }}>
        {Array.isArray(proof_data) && proof_data.length > 0 ? (
          proof_data.map((item) => (
            <Box
              key={item.id}
              sx={{
                mb: 3,
                p: 0,
              }}
            >
              {/* Embedded PDF */}
              <iframe
                src={`${item.url}#toolbar=0&navpanes=0&scrollbar=0`}
                type="application/pdf"
                width="100%"
                height="1300px"
                title={`Proof ${item.id}`}
                style={{ border: 'none' }}
              />

              {/* Metadata */}
              <Typography variant="subtitle1" fontWeight="600" sx={{ mt: 2 }}>
                {item.file_name || "No file name available"}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            No proof data available.
          </Typography>
        )}
      </Box>
    </>
  );
};

export default ProofBody;
